module.exports = __webpack_public_path__ + "img/diners-club.27ad9d5e.svg";